// 앱 안 브라우저(인스타·카카오 등)에서 크롬·사파리로 넘어갈 때 쓰는 공용 도구
// - 예약 선택(lafia_booking_draft_v2)과 언어를 주소에 실어 보내고, 새 브라우저에서 되살린다(브라우저마다 저장소가 따로라 그냥 넘기면 고른 것이 사라진다).
// - 안드로이드는 크롬을 바로 여는 intent 주소를 만든다.
// - 창이 뜨고 눌렸는지 구글 애널리틱스에 남긴다(10/5 '크롬으로 열기' 누름 기록이 없었음).
const HANDOFF_PARAM = "lafiaHandoff"
const DRAFT_KEY = "lafia_booking_draft_v2"

const encode = (value) => btoa(unescape(encodeURIComponent(JSON.stringify(value)))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
const decode = (value) => JSON.parse(decodeURIComponent(escape(atob(value.replace(/-/g, "+").replace(/_/g, "/")))))

export function trackInApp(action, params = {}) {
  try {
    if (typeof window.gtag === "function") window.gtag("event", `inapp_${action}`, { ...params, page_path: window.location.pathname })
  } catch (error) {}
}

// 지금 주소에 예약 선택·언어를 실은 주소
export function handoffUrl(lang) {
  const url = new URL(window.location.href)
  const payload = { lang }
  try {
    const draft = window.localStorage.getItem(DRAFT_KEY)
    if (draft) payload.draft = JSON.parse(draft)
  } catch (error) {}
  url.searchParams.set(HANDOFF_PARAM, encode(payload))
  return url.toString()
}

export function isAndroid(userAgent = navigator.userAgent) {
  return /Android/i.test(userAgent)
}

// 안드로이드 크롬 바로 열기(크롬이 없으면 같은 주소를 기본 브라우저로)
export function androidChromeIntentUrl(targetUrl) {
  const url = new URL(targetUrl)
  return `intent://${url.host}${url.pathname}${url.search}${url.hash}#Intent;scheme=${url.protocol.replace(":", "")};package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(targetUrl)};end`
}

// 새 브라우저에서 처음 열릴 때: 실려 온 예약 선택·언어를 되살리고 주소에서 지운다
export function restoreHandoff(store) {
  try {
    const url = new URL(window.location.href)
    const raw = url.searchParams.get(HANDOFF_PARAM)
    if (!raw) return
    url.searchParams.delete(HANDOFF_PARAM)
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash)
    const payload = decode(raw)
    if (payload && payload.draft && typeof payload.draft === "object") window.localStorage.setItem(DRAFT_KEY, JSON.stringify(payload.draft))
    if (payload && ["ko", "en", "jp"].includes(payload.lang) && store) store.commit("SET_LANG", payload.lang)
    trackInApp("handoff_arrived")
  } catch (error) {}
}
